import icon1 from '../assets/spekers image/1.png';
import icon2 from '../assets/spekers image/2.png';
import icon3 from '../assets/spekers image/3.png';
import icon4 from '../assets/spekers image/4.png';
import icon5 from '../assets/spekers image/5.png';
import icon6 from '../assets/spekers image/6.png';
import icon7 from '../assets/spekers image/7.png';
import icon8 from '../assets/spekers image/7.png';
import icon9 from '../assets/spekers image/8.png';
import icon10 from '../assets/spekers image/10.png';
import icon11 from '../assets/spekers image/9.png';
import SuhasIAS from '../assets/spekers image/Suhas IAS.jpg';
import Kesavan from '../assets/spekers image/Mr. T R Kesavan.jpg';
import FaizalKottikollon from '../assets/spekers image/Mr. Faizal Kottikollon.jpg';
import Seshadri from '../assets/spekers image/Mr. P. R. Seshadri, MD.jpg';
// import Vijayakumar from '../assets/spekers image/Mr. M P Vijayakumar.jpg';
import SandeepSikka from '../assets/spekers image/Mr. Sandeep Sikka.jpg';
import icon12 from '../assets/spekers image/12.png';
import guest2 from '../assets/spekers image/guest2.png';
import guest1 from '../assets/spekers image/guest1.png';



export const data = [
    {
        title: 'Dr. Shashi Tharoor',
        content: 'Member of Parliament, Thiruvanathapuram, Kerala',
        color: '#4ED6F9',
        image: guest2
    },
    {
        title: 'Mr. Deepak Parekh ',
        content: 'Chairman, HDFC Life Insurance Company Ltd',
        color: '#4ED6F9',
        image: guest1
    },
    {
        title: 'Mr. Suman Billa IAS',
        content: 'Principal Secretary, Industries, NORKA',
        color: '#4EF0E6A6',
        image: icon3
    },
    {
        title: 'Mr. C Balagopal ',
        content: 'Founder, Terumo Penpol Ltd Former Chairman, Federal Bank',
        color: '#4EF0E6A6',
        image: icon4
    },
    {
        title: 'Mr. Shahab Al Jassmi',
        content: 'Sr. VP (Commercial - Ports & Terminal),DP World, UAE',
        color: '#4ED6F9',
        image: icon1
    },
    {
        title: 'Mr. Kishor Rungta',
        content: 'CMD, FACT',
        color: '#4EF0E6A6',
        image: icon6
    },
    {
        title: 'Mr. K. Harikumar',
        content: 'Managing Director,TCC Ltd. & Malabar Cements Ltd',
        color: '#4EF0E6A6',
        image: icon5
    },
    // {
    //     title: 'Mr. Kochouseph Chittilappilly',
    //     content: 'Founder and Chairman Emeritu V-Guard Industries',
    //     color: '#4EF0E6A6',
    //     image: icon8
    // },
    {
        title: 'Mr. Aju Jacob ',
        content: 'Jt Managing Director, Synthite Industries Ltd',
        color: '#4EF0E6A6',
        image: icon9
    },

    {
        title: 'Mr. Thomas John',
        content: 'Managing Director,Agappe Diagnostics Ltd',
        color: '#4EF0E6A6',
        image: icon10
    },
    {
        title: 'Ms. Pamela Anna Mathew',
        content: 'Managing Director,O/E/N India Ltd',
        color: '#4EF0E6A6',
        image: icon11
    },
    {
        title: 'Mr. Prasad K Panicker',
        content: 'Chairman & Managing Director, Nayara Energy Limited ',
        color: '#4EF0E6A6',
        image: icon7
    },
    {
        title: 'Mr. Mohan Murti',
        content: 'Formar MD, Reliance Europe Supervisory Board Member - Innoplexus AG, Germany',
        color: '#1388E5B2',
        image: icon2
    },
    {
        title: 'Dr. Qaisar Metawea',
        content: 'Managing Partner, Dr. Qaisar H Metawea Law Firm',
        color: '#4EF0E6A6',
        image: icon12
    },
    {
        title: "Mr. Suhas IAS",
        content: 'CMD, Cochin International Airport Ltd.',
        color: '#4EF0E6A6',
        image: SuhasIAS
    },
    {
        title: "Mr. T R Kesavan",
        content: 'Group President, TAFE',
        color: '#4EF0E6A6',
        image: Kesavan
    },
    {
        title: "Mr. Faizal Kottikollon",
        content: 'Founder and Chairman-KEF Holdings, Dubai, UAE',
        color: '#4EF0E6A6',
        image: FaizalKottikollon
    },
    {
        title: "Mr. P. R. Seshadri",
        content: 'MD and CEO of South Indian Bank',
        color: '#4EF0E6A6',
        image: Seshadri
    },
    // {
    //     title: "Mr. M P Vijayakumar",
    //     content: 'CFO SIFY Corp, Board Member Airindia and LIC',
    //     color: '#4EF0E6A6',
    //     image: Vijayakumar
    // },
    {
        title: "Mr. Sandeep Sikka",
        content: 'ED and CEO, Nippon Life India Asset Mgmt Ltd',
        color: '#4EF0E6A6',
        image: SandeepSikka
    },


]